<template>
	<div v-cloak class="component-container component-modal modal-container minified-sidebar">
		<div class="modal-inner modal-positioning">
			<div class="modal-inner-container">
				<div class="modal-header">
					<slot name="header" />
					<button class="modal-close btn btn-icon" title="Close Overlay" @click="close">
						<fa :icon="['fas', 'times']" />
					</button>
				</div>
				<div class="modal-content">
					<slot name="content" />
				</div>
				<div v-if="hasFooterSlot" class="modal-footer">
					<slot name="footer" />
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
	import { Options, Vue } from 'vue-class-component';

	@Options({
		name: 'Modal',
		emits: ['close'],
	})
	export default class Modal extends Vue {

		public get hasFooterSlot(): boolean {
			return typeof this.$slots.footer !== 'undefined';
		}

		public close(): void {
			this.$emit('close');
		}
	}
</script>

<style lang="scss" scoped>
	@import '../assets/styles/base';
	@import '../assets/styles/modules/modal';
	@import '../assets/styles/modules/button';
</style>
